import { Component, OnInit, ChangeDetectorRef, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { NgForm } from '@angular/forms';
import { PucaQuestionnaireService } from "./service/puca-questionnaire.service";
import { HecResponse } from "../../../../../../../../src/app/shared/shared-interfaces/hecResponse";
import { HEC_CONSTANTS } from "../../../../../../../../src/app/utilities/constants";
import { MatDialog, MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { CommonHelper } from '../../../../../../utilities/common.helper';
import { PucaQuestionnaireModel } from "./model/puca-questionnaire-model";
import {
	SavePucaQuestionnaireModel,
	pucaPreferencesModel,
	pucaGreModel,
	pucaHatModel,
} from "./model/save-puca-questionnaire-model";
import { decrypt } from "../../../../../../../../src/app/utilities/utilityFunctions";
import { PucaFormService } from '../puca-form.service';
import { PucaComponent } from '../../../puca.component';
import { LoaderService } from '../../../../../../../../src/app/shared/sharedServices/loader.service';
import { SharedService } from '../../../../../../../../src/app/shared/sharedServices/shared.service';
import { PucaDataService } from "../../../services/puca-data.service";
import { EligibilityModalComponent } from "../../../../../../../../src/app/shared/shared-components/modal/eligibility-modal/eligibility-modal.component";
import moment from 'moment';


@Component({
	selector: "kt-puca-questionnaire",
	templateUrl: "./puca-questionnaire.component.html",
	styleUrls: ["./puca-questionnaire.component.scss"],
})
export class PucaQuestionnaireComponent implements OnInit {

	@ViewChild('form', { static: false })
	form: NgForm = null;

	public PucaQuestionnaire: PucaQuestionnaireModel = new PucaQuestionnaireModel();
	public dropdownList: any = {};
	public alertClass =
		"alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40";
	public alertIcon = "fa fa-exclamation-triangle";
	public isAlertVisible = false;
	alertMsgValue: string;
	ShowSecondQuestion: boolean = false;
	ShowThirdQuestion: boolean = false;
	profile: any;
	@Input() pucaApplication: any;
	@Input('formType') formType: string;
	public loader: boolean = false;
	@Input() isAdmin: boolean = false;
	@Output() setNewPucaApplication = new EventEmitter();
	public totalErrorMessage: string = '';
	public istotalError: boolean = false;
	isHattotalError: boolean;
	ShowForthQuestion: boolean = false;
	employmentDto: any;
	age: any;
	dob: Date;
	isChecked: boolean;
	isFirstChecked: boolean;
	disableSecondQuestionYearSelection = true;
	disableFirstQuestionYearSelection = true;
	private hasInitializedAdmissionYear = false;
	constructor(
		private router: Router,
		private cdr: ChangeDetectorRef,
		private matDialog: MatDialog,
		private pucaQuestionnaireService: PucaQuestionnaireService,
		private pucaFormService: PucaFormService,
		private parentComp: PucaComponent,
		private loaderService: LoaderService,
		private sharedServices: SharedService,
		public _snackBar: MatSnackBar,
		public pucaDataService: PucaDataService,
	) {
	}

	ngOnInit() {
		this.loaderService.setValue(true)
		this.profile = JSON.parse(
			decrypt(localStorage.getItem("esp-profile-details"))
		);

		this.dob = new Date(+decrypt(localStorage.getItem(('dob'))))
		this.age = moment().diff(this.dob, 'years');

		this.getUniversityListUS();
		this.getApplicationFormData();

	}

	ngAfterViewInit(): void {
		//EDIT MODE :START
		this.EditPucaForm();
		// EDIT MODE: END
	}
	private EditPucaForm() {

		this.loaderService.setValue(true)
		if (this.pucaApplication) {
			const pucaApplication = this.pucaApplication.pucaApplicationDto;
			const preferences = (this.pucaApplication.pucaPreferencesDtoList && this.pucaApplication.pucaPreferencesDtoList.length > 0) ? this.pucaApplication.pucaPreferencesDtoList[0] : [new pucaPreferencesModel()];
			if (pucaApplication.categoryTypeId && pucaApplication.categoryTypeId == '32255') {
				//FIRST QUESTION SELECTED
				this.changeFirstQuestion("1");
				this.PucaQuestionnaire.FirstQuestion.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;
				this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement = pucaApplication.isFacultyResearcher;
				this.PucaQuestionnaire.FirstQuestion.University = preferences.qsUniversityName;
				this.PucaQuestionnaire.FirstQuestion.UniversityRanking = preferences.qsUniversityRank;
				this.PucaQuestionnaire.FirstQuestion.UniversityRankingLink = preferences.qsUniversityRankLink;
				if (this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement) {
					this.PucaQuestionnaire.FirstQuestion.Employment = pucaApplication.employment
					this.PucaQuestionnaire.FirstQuestion.Age = pucaApplication.age;
				}
				this.changeIsRegularFacultyFirstQuestion(pucaApplication.isFacultyResearcher ? "1" : "0");

				this.changedfirstQuestionSemesterSelection(preferences.semesterId);
				this.changedfirstQuestionYearSelection(Number(preferences.semesterYear));
				this.PucaQuestionnaire.FirstQuestion.UniversityDepartment = preferences.department;
				this.PucaQuestionnaire.FirstQuestion.AdmissionSemester = preferences.semesterId;

				this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking = preferences.isQsSubjectRanking;
				this.PucaQuestionnaire.FirstQuestion.qsSubjectRank = Number(preferences.qsSubjectRank);
				this.cdr.detectChanges();
				this.isChecked = this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking;
				this.cdr.detectChanges()
			}
			else if (pucaApplication.categoryTypeId && pucaApplication.categoryTypeId == '32252') {
				//SECOND QUESTION SELECTED
				this.changeFirstQuestion("0");
				this.changeSecondQuestion("1");
				this.PucaQuestionnaire.SecondQuestion.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;
				this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement = pucaApplication.isFacultyResearcher;
				if (this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement) {
					this.PucaQuestionnaire.SecondQuestion.Employment = pucaApplication.employment
					this.PucaQuestionnaire.SecondQuestion.Age = pucaApplication.age;
				}
				this.changeIsRegularFacultySecondQuestion(pucaApplication.isFacultyResearcher ? "1" : "0");
				this.changedsecondQuestionYearSelection(Number(preferences.semesterYear));
				this.PucaQuestionnaire.SecondQuestion.University = preferences.qsUniversityName;
				this.PucaQuestionnaire.SecondQuestion.UniversityRanking = preferences.qsUniversityRank;
				this.PucaQuestionnaire.SecondQuestion.UniversityRankingLink = preferences.qsUniversityRankLink;
				this.PucaQuestionnaire.SecondQuestion.UniversityDepartment = preferences.department;
				this.PucaQuestionnaire.SecondQuestion.AdmissionSemester = preferences.semesterId;
				this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking = preferences.isQsSubjectRanking;

				this.PucaQuestionnaire.SecondQuestion.qsSubjectRank = Number(preferences.qsSubjectRank);
				this.cdr.detectChanges()
				this.isChecked = this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking;
				this.cdr.detectChanges()

			}
			else if (pucaApplication.categoryTypeId && pucaApplication.categoryTypeId == '32251') {
				//Third QUESTION SELECTED
				this.changeFirstQuestion("0");
				this.changeSecondQuestion("0");
				this.changeThirdQuestion("1");
				this.PucaQuestionnaire.ThirdQuestion.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;
				this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement = pucaApplication.isFacultyResearcher;
				if (this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement) {
					this.PucaQuestionnaire.ThirdQuestion.Employment = pucaApplication.employment
					this.PucaQuestionnaire.ThirdQuestion.Age = pucaApplication.age;
				}
				this.changeIsRegularFacultyThirdQuestion(pucaApplication.isFacultyResearcher ? "1" : "0");
				this.changedthirdQuestionUniversitySelection(preferences.universityId);
				this.changedthirdQuestionSemesterSelection(preferences.semesterId);
				this.changedthirdQuestionYearSelection(Number(preferences.semesterYear));
				this.PucaQuestionnaire.ThirdQuestion.UniversityDepartment = preferences.department;
				this.PucaQuestionnaire.ThirdQuestion.AdmissionSemester = preferences.semesterId;
				this.cdr.detectChanges()
			}
			else if (pucaApplication.categoryTypeId && pucaApplication.categoryTypeId == '32253') {
				//FORTH QUESTION SELECTED
				this.changeFirstQuestion("0");
				this.changeSecondQuestion("0");
				this.changeThirdQuestion("0");
				// this.changeForthQuestion(this.setNoCategory3(this.pucaApplication) ? "0" : "1");
				this.changeForthQuestion("1")

				// if (this.setNoCategory3(this.pucaApplication)) this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;

				this.PucaQuestionnaire.ForthQuestion.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;
				this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement = pucaApplication.isFacultyResearcher;
				this.changeIsRegularFacultyForthQuestion(pucaApplication.isFacultyResearcher ? "1" : "0");
				if (this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement) {
					this.PucaQuestionnaire.ForthQuestion.Employment = pucaApplication.employment
					this.PucaQuestionnaire.ForthQuestion.Age = pucaApplication.age;
				}
				// if (this.pucaApplication.isHat) {
				// 	this.GREorHAT("0");
				// 	const Hat = this.pucaApplication.pucaHatDtoList[0];
				// 	this.PucaQuestionnaire.ForthQuestion.HAT.RegistrationNumber = Hat.registrationNumber;
				// 	this.PucaQuestionnaire.ForthQuestion.HAT.TotalScoreObtained = Hat.totalScore;
				// 	this.PucaQuestionnaire.ForthQuestion.HAT.PercentageObtained = Hat.obtainedScore;
				// 	this.PucaQuestionnaire.ForthQuestion.HAT.TestDate = new Date(Hat.testDate).toISOString();
				// }

				// else if (this.pucaApplication.isGre) {
				// 	this.GREorHAT("1");
				// 	const Gre = this.pucaApplication.pucaGreDtoList[0];
				// 	this.PucaQuestionnaire.ForthQuestion.GRE.AnalyticalWriting = Gre.analyticalScore;
				// 	this.PucaQuestionnaire.ForthQuestion.GRE.QuantitativeReasoning = Gre.quantitativeScore;
				// 	this.PucaQuestionnaire.ForthQuestion.GRE.RegistrationNumber = Gre.analyticalScore;
				// 	this.PucaQuestionnaire.ForthQuestion.GRE.TestDate = new Date(Gre.date).toISOString();
				// 	this.PucaQuestionnaire.ForthQuestion.GRE.VerbalReasoning = Gre.verbalScore;
				// 	this.calculateTotalAndPercentage();
				// }



			}
			// else if (pucaApplication.categoryTypeId && pucaApplication.categoryTypeId == '32254')
			// {
			// 	this.changeFirstQuestion("0");
			// 	this.changeSecondQuestion("0");
			// 	this.changeForthQuestion("0");

			// 	this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch = (pucaApplication.areaOfResearchId) ? pucaApplication.areaOfResearchId : 0;
			// }
		}
		else if (!this.pucaApplication) {
			console.log("here first")
			this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking = true;
			this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking = true;
			this.isChecked = true;
		}
		this.loaderService.setValue(false)
	}

	public changeFirstQuestion(e) {
		this.PucaQuestionnaire.isSecondQuestionSelected = this.PucaQuestionnaire.isThirdQuestionSelected = this.PucaQuestionnaire.isForthQuestionSelected = null;
		if (e == 1) {
			this.PucaQuestionnaire.isFirstQuestionSelected = "1";
			this.ShowSecondQuestion = false;
			this.ShowThirdQuestion = false;
			this.ShowForthQuestion = false;
		} else if (e == 0) {
			this.PucaQuestionnaire.isFirstQuestionSelected = "0";
			this.ShowSecondQuestion = true;
			this.form.resetForm();
			// if (this.pucaDataService.isCategory1 && this.formType != 'view') this.ModalComponent(EligibilityModalComponent, 'PUCA SERVICE', 'You are not Eligible for this scholarship. Only those applicants are eligible who have secured admission along with tuition waiver in one of the listed/designated US Universities.')
		}
		else this.PucaQuestionnaire.isFirstQuestionSelected = "2";
		console.log("change", this.PucaQuestionnaire.isFirstQuestionSelected)
	}

	public getFirstQuestionSelectedUniversity(e, v): void {
		this.PucaQuestionnaire.FirstQuestion.University = e;
	}

	public getFirstQuestionSelectedAdmissionSemester(e, v): void {
		this.PucaQuestionnaire.FirstQuestion.AdmissionSemester = e;
	}
	public getSecondQuestionSelectedAdmissionSemester(e, v): void {
		this.PucaQuestionnaire.SecondQuestion.AdmissionSemester = e;
	}
	// Area of research

	public getFirstQuestionSelectedAreaOfResearch(e, v): void {
		this.PucaQuestionnaire.FirstQuestion.AreaOfResearch = e;
	}
	public getSecondQuestionSelectedAreaOfResearch(e, v): void {
		this.PucaQuestionnaire.SecondQuestion.AreaOfResearch = e;
	}
	public getThirdQuestionSelectedAreaOfResearch(e, v): void {
		this.PucaQuestionnaire.ThirdQuestion.AreaOfResearch = e;
	}

	public getForthQuestionSelectedAreaOfResearch(e, v): void {
		this.PucaQuestionnaire.ForthQuestion.AreaOfResearch = e;
	}
	// Employment
	public getFirstQuestionSelectedEmployement(e, v): void {
		this.PucaQuestionnaire.FirstQuestion.Employment = e;
	}
	public getSecondQuestionSelectedEmployement(e, v): void {
		this.PucaQuestionnaire.SecondQuestion.Employment = e;
	}
	public getThirdQuestionSelectedEmployement(e, v): void {
		this.PucaQuestionnaire.ThirdQuestion.Employment = e;
	}
	public getForthQuestionSelectedEmployement(e, v): void {
		this.PucaQuestionnaire.ThirdQuestion.Employment = e;
	}

	// Faculty

	public changeIsRegularFacultyFirstQuestion(e) {
		this.PucaQuestionnaire.FirstQuestion.Age = this.age
		if (e == 1) {
			this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement = true;
		} else {
			this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement = false;
		}
	}

	public changeIsRegularFacultySecondQuestion(e) {
		this.PucaQuestionnaire.SecondQuestion.Age = this.age
		if (e == 1) {
			this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement = true;
		} else {
			this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement = false;
		}
	}

	public changeIsRegularFacultyThirdQuestion(e) {
		this.PucaQuestionnaire.ThirdQuestion.Age = this.age
		if (e == 1) {
			this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement = true;
		} else {
			this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement = false;
		}
	}
	public changeIsRegularFacultyForthQuestion(e) {
		this.PucaQuestionnaire.ForthQuestion.Age = this.age
		if (e == 1) {
			this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement = true;
		} else {
			this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement = false;
		}
	}

	GREorHAT(e) {
		if (e == 1) {
			this.PucaQuestionnaire.ForthQuestion.isGRE = true;
			this.PucaQuestionnaire.ForthQuestion.isHAT = false;
		} else {
			this.PucaQuestionnaire.ForthQuestion.isHAT = true;
			this.PucaQuestionnaire.ForthQuestion.isGRE = false;
		}
	}

	public changeSecondQuestion(e) {
		this.PucaQuestionnaire.isThirdQuestionSelected = this.PucaQuestionnaire.isForthQuestionSelected = null;
		if (e == 1) {
			this.PucaQuestionnaire.isSecondQuestionSelected = true;
			this.ShowThirdQuestion = false;
			this.ShowForthQuestion = false;

		} else {
			console.log("hello")
			this.PucaQuestionnaire.isSecondQuestionSelected = false;
			//			this.ShowThirdQuestion = true;
			//			this.ShowForthQuestion = false;

			this.PucaQuestionnaire.isThirdQuestionSelected = false;
			this.ShowForthQuestion = true;
		}
	}

	public changeThirdQuestion(e) {
		this.PucaQuestionnaire.isForthQuestionSelected = null;
		if (e == 1) {
			this.PucaQuestionnaire.isThirdQuestionSelected = true;
			this.ShowForthQuestion = false;
		} else {
			this.PucaQuestionnaire.isThirdQuestionSelected = false;
			this.ShowForthQuestion = true;
		}
	}

	public changeForthQuestion(e) {
		if (e == 1) {
			this.PucaQuestionnaire.isForthQuestionSelected = true;
		} else {
			this.PucaQuestionnaire.isForthQuestionSelected = false;
			// if (this.pucaDataService.isCategory1 && this.formType != 'view') this.ModalComponent(EligibilityModalComponent, 'PUCA SERVICE', 'You are not Eligible for this scholarship. Only those applicants are eligible who have secured admission along with tuition waiver in one of the listed/designated US Universities.')
		}
	}

	//isQSRanking -Q1
	public changeIsQsSubjectRankingFirstQuestion(e) {
		if (e == 1) {
			this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking = true;
			this.PucaQuestionnaire.FirstQuestion.qsSubjectRank = null;
			this.isChecked = true;
		} else {
			this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking = false;
			this.PucaQuestionnaire.FirstQuestion.qsSubjectRank = null;
			this.isChecked = false;
		}
	}

	//isQSRanking -Q2
	public changeIsQsSubjectRankingSecondQuestion(e) {
		if (e == 1) {
			this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking = true;
			this.PucaQuestionnaire.SecondQuestion.qsSubjectRank = null;
			this.isChecked = true;
		} else {
			this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking = false;
			this.PucaQuestionnaire.SecondQuestion.qsSubjectRank = null;
			this.isChecked = false;
		}
	}

	public ModalComponent(Component, title?, message?, type?): any {
		const dialogRef = this.matDialog.open(Component, {
			width: "70vw",
			height: "60vh",
			backdropClass: "landingpage-popup",
			panelClass: "landingpage-popup-inner",
			disableClose: true,
			autoFocus: false,
			data: { title: title, message: message },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) this.router.navigate(["/"]);
		});
	}

	public calculateTotalAndPercentage() {
		// const total = Number(this.PucaQuestionnaire.ThirdQuestion.GRE.VerbalReasoning) + Number(this.PucaQuestionnaire.ThirdQuestion.GRE.QuantitativeReasoning)
		// if (total > 340) {
		// 	this.PucaQuestionnaire.ThirdQuestion.GRE.VerbalReasoning = "0";
		// 	this.PucaQuestionnaire.ThirdQuestion.GRE.QuantitativeReasoning = "0"
		// 	this.istotalError = true;
		// 	this.totalErrorMessage = "Total Shouldn't be greater than 340"
		// 	return false;
		// }
		// this.istotalError = false;
		// this.PucaQuestionnaire.ThirdQuestion.GRE.Total = total.toString();
		// this.PucaQuestionnaire.ThirdQuestion.GRE.Percentage = Number(Number(this.PucaQuestionnaire.ThirdQuestion.GRE.Total) * 100 / HEC_CONSTANTS.PUCA_CONSTANTS.PERCENTAGE_OUT_OF).toFixed(2) + '';
	}

	public dateChangedGRE(e) {
		//	this.PucaQuestionnaire.ThirdQuestion.GRE.TestDate = e;
	}

	public dateChangedHAT(e) {
		//	this.PucaQuestionnaire.ThirdQuestion.HAT.TestDate = e;
	}

	public saveQuestionnaire() {
		// if(this.formT)
		this.isAlertVisible = false;
		if (this.formType == 'view') {
			this.pucaFormService.nextStep.next(true);
			return false;
		}
		if (this.isAllQuestionsNoSelected()) {
			this.ModalComponent(EligibilityModalComponent, 'PUCA SERVICE', 'You are not Eligible for this scholarship.');
			return;

		}

		this.markFormsTouched(this.form);
		if (!this.formValid(this.form)) {
			console.log(this.form)
			return;
		}


		// if (this.pucaDataService.isCategory1 && this.PucaQuestionnaire.isFirstQuestionSelected != "1") {
		// 	this.ModalComponent(EligibilityModalComponent, 'PUCA SERVICE', 'You are not Eligible for this scholarship. Only those applicants are eligible who have secured admission along with tuition waiver in one of the listed/designated US Universities.');
		// 	return;
		// }

		const profile = JSON.parse(
			decrypt(localStorage.getItem("esp-profile-details"))
		);
		let payload: SavePucaQuestionnaireModel = new SavePucaQuestionnaireModel();
		payload.commonProfileId = profile["profileId"];
		payload.exactName = profile["fullName"];
		if (this.PucaQuestionnaire.isFirstQuestionSelected == "1"
			&& this.PucaQuestionnaire.FirstQuestion.AreaOfResearch
			&& this.PucaQuestionnaire.FirstQuestion.UniversityDepartment
			&& this.PucaQuestionnaire.FirstQuestion.University
			&& this.PucaQuestionnaire.FirstQuestion.AdmissionSemester) {
			// first question
			payload.categoryTypeId = '32255';
			payload.isGre = true;
			payload.isAdmissionAttained = true;
			payload.isScholarshipAvailing = true;
			payload.areaOfResearchId = Number(this.PucaQuestionnaire.FirstQuestion.AreaOfResearch);
			delete payload.proposedFieldOfStudy;
			payload.isFacultyResearcher = this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement;
			const preferences: pucaPreferencesModel = new pucaPreferencesModel();
			preferences.department = this.PucaQuestionnaire.FirstQuestion.UniversityDepartment;
			delete preferences.universityId
			preferences.semesterId = this.PucaQuestionnaire.FirstQuestion.AdmissionSemester;
			preferences.semesterYear = this.PucaQuestionnaire.FirstQuestion.AdmissionYear;
			preferences['qsUniversityName'] = this.PucaQuestionnaire.FirstQuestion.University;
			preferences["qsUniversityRankLink"] = this.PucaQuestionnaire.FirstQuestion.UniversityRankingLink;
			preferences["qsUniversityRank"] = Number(this.PucaQuestionnaire.FirstQuestion.UniversityRanking);

			preferences['isQsSubjectRanking'] = this.PucaQuestionnaire.FirstQuestion.isQsSubjectRanking;
			preferences['qsSubjectRank'] = this.PucaQuestionnaire.FirstQuestion.qsSubjectRank;
			payload.pucaPreferencesDtoList.push(preferences);
			if (this.PucaQuestionnaire.FirstQuestion.isCurrentEmployement) {
				payload.employment = this.PucaQuestionnaire.FirstQuestion.Employment;
				payload.age = this.PucaQuestionnaire.FirstQuestion.Age;
			}
		}
		else if (
			this.PucaQuestionnaire.isSecondQuestionSelected == true
			&& this.PucaQuestionnaire.SecondQuestion.AreaOfResearch
			&& this.PucaQuestionnaire.SecondQuestion.University
			&& this.PucaQuestionnaire.SecondQuestion.UniversityRankingLink
			&& Number(this.PucaQuestionnaire.SecondQuestion.UniversityRanking) > 0
			&& this.PucaQuestionnaire.SecondQuestion.UniversityDepartment
		) {
			//second question
			console.log("second Q")
			payload.isAdmissionAttained = true;
			payload.isGre = true;
			payload.isScholarshipAvailing = false;
			payload.categoryTypeId = '32252';
			payload.areaOfResearchId = Number(this.PucaQuestionnaire.SecondQuestion.AreaOfResearch);
			delete payload.proposedFieldOfStudy;
			payload.isFacultyResearcher = this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement;
			const preferences: pucaPreferencesModel = new pucaPreferencesModel();
			preferences['qsUniversityName'] = this.PucaQuestionnaire.SecondQuestion.University;
			preferences["qsUniversityRankLink"] = this.PucaQuestionnaire.SecondQuestion.UniversityRankingLink;
			preferences["qsUniversityRank"] = Number(this.PucaQuestionnaire.SecondQuestion.UniversityRanking);
			preferences.department = this.PucaQuestionnaire.SecondQuestion.UniversityDepartment;
			delete preferences.universityId;
			preferences.semesterId = this.PucaQuestionnaire.SecondQuestion.AdmissionSemester;
			preferences.semesterYear = this.PucaQuestionnaire.SecondQuestion.AdmissionYear;
			preferences['isQsSubjectRanking'] = this.PucaQuestionnaire.SecondQuestion.isQsSubjectRanking;
			preferences['qsSubjectRank'] = this.PucaQuestionnaire.SecondQuestion.qsSubjectRank;


			payload.pucaPreferencesDtoList.push(preferences);
			if (this.PucaQuestionnaire.SecondQuestion.isCurrentEmployement) {
				payload.employment = this.PucaQuestionnaire.SecondQuestion.Employment;
				payload.age = this.PucaQuestionnaire.SecondQuestion.Age;
			}
		}
		else if (this.PucaQuestionnaire.isThirdQuestionSelected == true
			&& this.PucaQuestionnaire.ThirdQuestion.AreaOfResearch
			&& this.PucaQuestionnaire.ThirdQuestion.UniversityDepartment
			&& this.PucaQuestionnaire.ThirdQuestion.University
			&& this.PucaQuestionnaire.ThirdQuestion.AdmissionSemester) {
			//third question
			payload.categoryTypeId = '32251';
			payload.isAdmissionAttained = true;
			payload.isScholarshipAvailing = true;
			payload.areaOfResearchId = Number(this.PucaQuestionnaire.ThirdQuestion.AreaOfResearch);
			delete payload.proposedFieldOfStudy;
			payload.isFacultyResearcher = this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement;
			const preferences: pucaPreferencesModel = new pucaPreferencesModel();
			preferences.department = this.PucaQuestionnaire.ThirdQuestion.UniversityDepartment;
			preferences.universityId = this.PucaQuestionnaire.ThirdQuestion.University;
			preferences.semesterId = this.PucaQuestionnaire.ThirdQuestion.AdmissionSemester;
			preferences.semesterYear = this.PucaQuestionnaire.ThirdQuestion.AdmissionYear;
			payload.pucaPreferencesDtoList.push(preferences);
			if (this.PucaQuestionnaire.ThirdQuestion.isCurrentEmployement) {
				payload.employment = this.PucaQuestionnaire.ThirdQuestion.Employment;
				payload.age = this.PucaQuestionnaire.ThirdQuestion.Age;
			}
		}

		else if (this.PucaQuestionnaire.isForthQuestionSelected == true
			&& this.PucaQuestionnaire.ForthQuestion.AreaOfResearch
			//&& (this.PucaQuestionnaire.ForthQuestion.isGRE == true || this.PucaQuestionnaire.ForthQuestion.isHAT == true)
		) {
			if (this.PucaQuestionnaire.isForthQuestionSelected == true //&& (this.PucaQuestionnaire.ForthQuestion.isGRE == true || this.PucaQuestionnaire.ForthQuestion.isHAT == true)
			) {
				// forth question
				payload.isAdmissionAttained = false;
				payload.isScholarshipAvailing = false;
				payload.categoryTypeId = '32253';
				payload.areaOfResearchId = Number(this.PucaQuestionnaire.ForthQuestion.AreaOfResearch);
				payload.isFacultyResearcher = this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement;
				payload.isGre = true;
				if (this.PucaQuestionnaire.ForthQuestion.isCurrentEmployement) {
					payload.employment = this.PucaQuestionnaire.ForthQuestion.Employment;
					payload.age = this.PucaQuestionnaire.ForthQuestion.Age;
				}
				//if (this.PucaQuestionnaire.ForthQuestion.isGRE == true
				// 	&& Number(this.PucaQuestionnaire.ForthQuestion.GRE.AnalyticalWriting) > 0
				// 	&& Number(this.PucaQuestionnaire.ForthQuestion.GRE.QuantitativeReasoning) > 0
				// 	&& Number(this.PucaQuestionnaire.ForthQuestion.GRE.VerbalReasoning) > 0
				// 	&& this.PucaQuestionnaire.ForthQuestion.GRE.TestDate
				// 	) {
				// 	payload.isGre = true;
				// // 	payload.pucaGreDtoList = [];
				// // 	const gre = new pucaGreModel();
				// // 	gre.analyticalScore = Number(
				// // 		this.PucaQuestionnaire.ForthQuestion.GRE
				// // 			.AnalyticalWriting
				// // 	);
				// // 	gre.quantitativeScore = Number(
				// // 		this.PucaQuestionnaire.ForthQuestion.GRE
				// // 			.QuantitativeReasoning
				// // 	);
				// // 	gre.verbalScore = Number(
				// // 		this.PucaQuestionnaire.ForthQuestion.GRE
				// // 			.VerbalReasoning
				// // 	);
				// // 	gre.date = this.PucaQuestionnaire.ForthQuestion.GRE.TestDate;
				// // 	gre["totalScore"] = 340;
				// // 	gre["obtainedScore"] = Number(gre.quantitativeScore) + Number(gre.quantitativeScore);
				// // 	gre["percentage"] = Number(gre["obtainedScore"] / gre["totalScore"]) * 100;
				// // 	payload.pucaGreDtoList.push(gre);
				//  } else if (
				// 	this.PucaQuestionnaire.ForthQuestion.isHAT == true
				// 	&& this.PucaQuestionnaire.ForthQuestion.HAT.TestDate
				// 	&& Number(this.PucaQuestionnaire.ForthQuestion.HAT.PercentageObtained) > 0
				// 	&& Number(this.PucaQuestionnaire.ForthQuestion.HAT.TotalScoreObtained) > 0
				//  ) {
				//  	payload.isHat = true;
				// 	payload.pucaHatDtoList = [];
				// 	const hat = new pucaHatModel();
				// 	hat.testDate = this.PucaQuestionnaire.ForthQuestion.HAT.TestDate;
				// 	hat.obtainedScore = Number(
				// 		this.PucaQuestionnaire.ForthQuestion.HAT
				// 			.PercentageObtained
				// 	);
				// 	hat.totalScore = Number(
				// 		this.PucaQuestionnaire.ForthQuestion.HAT
				// 			.TotalScoreObtained
				// 	);
				// 	hat.percentage = (hat.obtainedScore / hat.totalScore) * 100
				// 	hat.registrationNumber = this.PucaQuestionnaire.ForthQuestion.HAT.RegistrationNumber;
				// 	payload.pucaHatDtoList.push(hat);
				// }
				// else {
				// 	this.alertMsgValue = "Please fill all the required fields";
				// 	this.isAlertVisible = true;
				// 	return false;
				// }
			}
		}
		// else if (this.PucaQuestionnaire.isThirdQuestionSelected == false
		// 	&& this.PucaQuestionnaire.isSecondQuestionSelected == false
		// 	&& this.PucaQuestionnaire.isFirstQuestionSelected != "1"
		// 	&& this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch) {
		// 	payload.isAdmissionAttained = false;
		// 	payload.isScholarshipAvailing = false;
		// 	payload.pucaHatDtoList = [];
		// 	payload.pucaGreDtoList = [];
		// 	payload.categoryTypeId = '32254';
		// 	payload.isGre = false;
		// 	payload.isHat = false;
		// 	payload.areaOfResearchId = Number(this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch);
		// }
		// else {
		// 	this.alertMsgValue = "Please fill all the required fields";
		// 	this.isAlertVisible = true;
		// 	return false;
		// }
		console.log(payload)
		this.saveApplication(payload);
	}

	private async saveApplication(payload) {
		try {

			this.loaderService.setValue(true)
			//console.log(this.pucaApplication)
			if (this.pucaApplication && this.pucaApplication.pucaApplicationDto && this.pucaApplication.pucaApplicationDto.id) {
				payload["id"] = this.pucaApplication.pucaApplicationDto.id;
			}

			console.log(payload);
			const res: HecResponse = await this.pucaQuestionnaireService
				.saveApplication(payload)
				.toPromise();

			this.loaderService.setValue(false)
			if (res.code == 0) {
				const pucaApplication: HecResponse = await this.sharedServices.getApplicationData(res.result.id).toPromise();
				this.setNewPucaApplication.emit(pucaApplication.result);
				this.pucaFormService.nextStep.next(true);
			}
			else {
				// this._snackBar.open(res.message, '', {
				// 	duration: 9500,
				// 	panelClass: ['error-snackbar']
				// });
				this.alertMsgValue = res.message;
				this.isAlertVisible = true;
				return false;
			}
		}
		catch (e) {
			this.loaderService.setValue(false)
		}
	}

	private async getUniversityListUS() {
		const res: any = await this.pucaFormService.getUniversityListUS().toPromise();
	}

	private async getApplicationFormData() {
		const ismax: any = await this.pucaFormService.isMaxApplicationExist(this.profile["profileId"]).toPromise();

		const res: any = await this.pucaFormService.getApplicationFormData((this.pucaApplication && this.pucaApplication.pucaApplicationDto && this.pucaApplication.pucaApplicationDto.id) ? this.pucaApplication.pucaApplicationDto.id : 0, this.profile["profileId"]).toPromise();
		if (res.code == 0 || res.statusCode == 200) {
			debugger
			const applicationData = (res.result) ? res.result : res.data;
			//this.fetchEmploymentDetais(applicationData.empHistoryDtoList)
			this.dropdownList['areaOfResearch'] = applicationData.areaOfResearchList;
			this.dropdownList['univeristy'] = applicationData.universityList; 
			// this.dropdownList['admissionSemester'] = HEC_CONSTANTS.PUCA_NEW_SEMESTER_LIST;//HEC_CONSTANTS.PUCA_SEMESTER_LIST;
			// this.dropdownList['admissionSemester'] = applicationData.semesterList;
			//this.dropdownList['admissionYear'] = HEC_CONSTANTS.PUCA_SEMESTER_YEAR_LIST;
			this.dropdownList['pucaBroadSubjectAreaDtoList'] = applicationData.pucaBroadSubjectAreaDtoList;
			// this.dropdownList['admissionYear'] = HEC_CONSTANTS.PUCA_NEW_SEMESTER_YEAR_LIST;

			this.setSelectedAdmissionDetails(applicationData);
			  
			this.loaderService.setValue(false);

			this.cdr.detectChanges();
		}
		this.cdr.detectChanges();
	}

	private setSelectedAdmissionDetails(applicationData: any): void {
		const hasPreferences =
			applicationData &&
			applicationData.pucaPreferencesDtoList &&
			applicationData.pucaPreferencesDtoList.length > 0;

			if (hasPreferences) {
				const preferences = applicationData.pucaPreferencesDtoList[0];
			
				// 💡 Admission Year setup
				const selectedYear = +preferences.semesterYear; // Convert to number if needed
			
				this.dropdownList['admissionYear'] = applicationData.admissionYears.map((year: number) => ({
					label: year.toString(),
					value: year
				}));
			
				const selectedYearObj = this.dropdownList['admissionYear'].find(
					(item: any) => item.value === selectedYear
				);
			
				if (selectedYearObj) {
					this.PucaQuestionnaire.SecondQuestion.AdmissionYear = selectedYearObj.value;
					console.log("Selected Year: ", this.PucaQuestionnaire.SecondQuestion.AdmissionYear);
					
				}
			
				// 💡 Admission Semester setup
				const selectedSemesterId = preferences.semesterId;

				this.getSemesterLists(this.PucaQuestionnaire.SecondQuestion.AdmissionYear, "yes", selectedSemesterId)

				return;
			}else{
				this.hasInitializedAdmissionYear = true;
			}
						

		// Fallback (if data is not valid or missing)
		if (applicationData.semesterList) {
			this.dropdownList['admissionSemester'] = applicationData.semesterList;
		}
		if (applicationData.admissionYears && Array.isArray(applicationData.admissionYears)) {
			this.dropdownList['admissionYear'] = applicationData.admissionYears.map((year: any) => ({
				label: year.toString(),
				value: year
			}));
		}
	}
	

	private async getSemesterLists(AdmissionYear: String, selectedSemester?: string, selectedSemesterId?: any) {
		const res: any = await this.pucaFormService.getSemesterlist(AdmissionYear).toPromise();

		// const res: any = await this.pucaFormService.getApplicationFormData((this.pucaApplication && this.pucaApplication.pucaApplicationDto && this.pucaApplication.pucaApplicationDto.id) ? this.pucaApplication.pucaApplicationDto.id : 0, this.profile["profileId"]).toPromise();
		if (res.code == 0 || res.statusCode == 200) {
			const applicationData = (res.result) ? res.result : res.data;

			console.log("Semester list : ", applicationData);

			if (selectedSemester == "yes") {
				// this.dropdownList['admissionSemester'] = applicationData.semesterListRes;
				this.dropdownList['admissionSemester'] = applicationData.semesterListRes.map(
					([value, label]: [number, string]) => ({ label, value })
				);

				const selectedSemesterObj = this.dropdownList['admissionSemester'].find(
					(item: any) => item.value === selectedSemesterId
				);

				if (selectedSemesterObj) {
					this.disableSecondQuestionYearSelection = false;
					this.disableFirstQuestionYearSelection = false;
					this.PucaQuestionnaire.SecondQuestion.AdmissionSemester = selectedSemesterObj.value;

					console.log("Selected Semester: ", this.PucaQuestionnaire.SecondQuestion.AdmissionSemester);
				}
			} else {
				this.dropdownList['admissionSemester'] = applicationData.semesterListRes.map(item => ({
					value: item[0],
					label: item[1]
				}));
			}

			this.cdr.detectChanges();
		}
		this.cdr.detectChanges();
	}

	public changedfirstQuestionUniversitySelection(e) {
		this.PucaQuestionnaire.FirstQuestion.University = e;
	}

	public changedthirdQuestionUniversitySelection(e) {
		this.PucaQuestionnaire.ThirdQuestion.University = e;
	}

	public changedfirstQuestionSemesterSelection(e) {
		this.PucaQuestionnaire.FirstQuestion.AdmissionSemester = e;
	}
	public changedthirdQuestionSemesterSelection(e) {
		this.PucaQuestionnaire.ThirdQuestion.AdmissionSemester = e;
	}
	public changedfirstQuestionYearSelection(e) {
		this.PucaQuestionnaire.FirstQuestion.AdmissionYear = e;
		if (!this.hasInitializedAdmissionYear) {
			this.hasInitializedAdmissionYear = true;
			return; // 🚫 Skip first trigger caused by setting default value
		}

		if (this.isValid(this.PucaQuestionnaire.FirstQuestion.AdmissionYear)) {
			this.disableFirstQuestionYearSelection = false;
			this.getSemesterLists(this.PucaQuestionnaire.FirstQuestion.AdmissionYear);
		} else {
			this.disableFirstQuestionYearSelection = true;
		}
	}
	public changedsecondQuestionYearSelection(e) {
		console.log("change called second ");

		if (!this.hasInitializedAdmissionYear) {
			this.hasInitializedAdmissionYear = true;
			return; // 🚫 Skip first trigger caused by setting default value
		}

		this.PucaQuestionnaire.SecondQuestion.AdmissionYear = e;
		if (this.isValid(this.PucaQuestionnaire.SecondQuestion.AdmissionYear)) {
			this.disableSecondQuestionYearSelection = false;
			this.getSemesterLists(this.PucaQuestionnaire.SecondQuestion.AdmissionYear);
		} else {
			this.disableSecondQuestionYearSelection = true;
		}
	}

	isValid(value: any): boolean {
		return value !== null && value !== undefined && value !== '';
	}

	public changedthirdQuestionYearSelection(e) {
		this.PucaQuestionnaire.ThirdQuestion.AdmissionYear = e;
	}

	public changedsecondQuestionSemesterSelection(e) {
		this.PucaQuestionnaire.SecondQuestion.AdmissionSemester = e;
	}
	public changedfirstQuestionAreaOfResearchSelection(e) {
		this.PucaQuestionnaire.FirstQuestion.AreaOfResearch = e;
	}
	public changedsecondQuestionAreaOfResearchSelection(e) {
		this.PucaQuestionnaire.SecondQuestion.AreaOfResearch = e;
	}
	public changedthirdQuestionAreaOfResearchSelection(e) {
		this.PucaQuestionnaire.ThirdQuestion.AreaOfResearch = e;
	}
	public changedforthQuestionAreaOfResearchSelection(e) {
		this.PucaQuestionnaire.ForthQuestion.AreaOfResearch = e;
	}
	public changedNoQuestionAreaOfResearchSelection(e) {
		this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch = e;
	}
	public changedfirstQuestionBroadSubjectSelection(e) {
		this.PucaQuestionnaire.FirstQuestion.qsSubjectRank = e;
	}
	public changedSecondQuestionBroadSubjectSelection(e) {
		this.PucaQuestionnaire.SecondQuestion.qsSubjectRank = e;
	}

	public goBack() {
		this.parentComp.goBack();
		this.cdr.detectChanges();
	}

	public cancelAttestaion() {
		if (this.isAdmin) {
			this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
		}
		else {
			this.router.navigate(['/'])
		}
	}


	public hatObtainedMarksChanged(event) {
		// this.isHattotalError = false
		// const obtainedScore = Number(
		// 	this.PucaQuestionnaire.ThirdQuestion.HAT
		// 		.PercentageObtained
		// );
		// const totalScore = Number(
		// 	this.PucaQuestionnaire.ThirdQuestion.HAT
		// 		.TotalScoreObtained
		// );
		// if (obtainedScore > totalScore) {
		// 	this.PucaQuestionnaire.ThirdQuestion.HAT
		// 		.PercentageObtained = "0";

		// 	this.isHattotalError = true;
		// }
	}

	setNoCategory3 = pucaApplication => {
		return this.formType == "view" &&
			(!pucaApplication.pucaGreDtoList || (pucaApplication.pucaGreDtoList && !pucaApplication.pucaApplicationDto.areaOfResearchId)) &&
			(pucaApplication.pucaHatDtoList && (pucaApplication.pucaHatDtoList[0].preferredTestCenterId || !pucaApplication.pucaApplicationDto.areaOfResearchId));
	}

	isAllQuestionsNoSelected() {
		console.log(this.PucaQuestionnaire.isFirstQuestionSelected, this.PucaQuestionnaire.isSecondQuestionSelected, this.PucaQuestionnaire.isThirdQuestionSelected, this.PucaQuestionnaire.isForthQuestionSelected)

		// return this.PucaQuestionnaire.isFirstQuestionSelected == "0" && !this.PucaQuestionnaire.isSecondQuestionSelected && !this.PucaQuestionnaire.isThirdQuestionSelected
		// 	&& !this.PucaQuestionnaire.isForthQuestionSelected;

		if(this.PucaQuestionnaire.isFirstQuestionSelected == "0" && !this.PucaQuestionnaire.isSecondQuestionSelected){
			return true;
		}else{
			return false;
		}
	}

	isNoCategoryPayload = () => {
		return this.PucaQuestionnaire.isThirdQuestionSelected == false
			&& this.PucaQuestionnaire.isSecondQuestionSelected == false
			&& this.PucaQuestionnaire.isFirstQuestionSelected != "1"
			&& this.PucaQuestionnaire.AllQuestionsNo.AreaOfResearch;
	}


	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public formValid(form): boolean {
		return form.valid;
	}

	fetchEmploymentDetais(data) {
		data.forEach((element) => {
			//currently employed
			//country = pakistan
			//sector = public
			//teaching experience != non teaching
			//catergory = university || R&D
			//job type = permanent
			if (element.current && element.employmentCountryId == 1 &&
				element.sectorCode == 100 && element.teachingExperienceTypeCode != '10662' && element.jobType == 10221 && (element.category == 10511 || element.category == 10421)) {

				this.employmentDto.universityName = element.universityName
				this.employmentDto.jobType = element.jobType
				this.employmentDto.designation = element.designation
			}
		});
	}

	public isCheckedBroadSubject() {
		return this.isChecked == false ? true : false
	}

}
